import { Component, Input } from '@angular/core';
import { Summary } from './models/summary.models';

@Component({
  selector: 'idp-overview-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent {
  @Input() content: Summary = {} as Summary;

  redirect(link: string) {
    window.open(link, '_blank');
  }

  getLogoClass(level: string) {
    if (+level > 20 || +level === 0) {
      return {
        background: 'var(--tracker-million-miler-globe) var(--no-repeat)'
      };
    } else {
      return {
        background: `var(--tracker-million-miler-${level}) var(--no-repeat)`,
        'background-size': 'var(--unit-36-px)'
      };
    }
  }
}
